@if (isInitialized) {
    <div class="ws-flex-container-vertical ws-flex-auto ws-stretch">
        <!-- import summary and current step visualization -->
        <div class="import-summary ws-flex-none ws-flex-container-horizontal ws-stretch-width">
            <div class="ws-flex-auto">
                <ws-bread-crumbs [breadcrumbs]="breadcrumbs"
                                 [currentPageTitle]="importFileDescription"></ws-bread-crumbs>
                @if (assetEffectiveDate) {
                    <div class="breadcrumb ws-flex-container-horizontal asset-info">
                        <div>Asset Effective date:</div>
                        <span>{{ assetEffectiveDate | date : 'M/d/yyyy' }}</span>
                        @if (assetOwnershipTypeName) {
                            <div> Asset Ownership type:</div>
                        }
                        @if (assetOwnershipTypeName) {
                            <span>{{ assetOwnershipTypeName }}</span>
                        }
                    </div>
                }
                @if (accrualAdjustmentAmountValueType) {
                    <div class="breadcrumb ws-flex-container-horizontal asset-info">
                        <div>Adjustment Amount Value type:</div>
                        <span>{{ accrualAdjustmentAmountValueType }}</span>
                    </div>
                }
                @if (isSiteUpdatesOnlyImport) {
                    <div class="breadcrumb ws-flex-container-horizontal asset-info">
                        <div>Match existing sites by:</div>
                        <span>{{ sitesUpdatesOnlyMatchBy }}</span>
                    </div>
                }
                @if (isTaxPaymentsImport) {
                    <div class="breadcrumb ws-flex-container-horizontal flex-nowrap asset-info">
                        <div>Match overall by:</div>
                        <span>{{ taxPaymentsMatchOverall }}</span>
                        @if (!isTaxPaymentsImportMatchByPaymentSystemId) {
                            <div>Match parcel using:</div>
                            <span>{{ taxPaymentsMatchParcel }}</span>
                            <div>Match collector using:</div>
                            <span>{{ taxPaymentsMatchCollector }}</span>
                        }
                    </div>
                }
                @if (incomeStatementsEndingDate) {
                    <div class="breadcrumb ws-flex-container-horizontal asset-info">
                        <div>Income Statements Ending date:</div>
                        <span>{{ incomeStatementsEndingDate | date : 'M/d/yyyy' }}</span>
                    </div>
                }
                @if (rentRollEndingDate) {
                    <div class="breadcrumb ws-flex-container-horizontal asset-info">
                        <div>Rent Roll Ending date:</div>
                        <span>{{ rentRollEndingDate | date : 'M/d/yyyy' }}</span>
                    </div>
                }
                @if (glAccountsIntendedUse) {
                    <div class="breadcrumb ws-flex-container-horizontal asset-info">
                        <div>Intended use:</div>
                        <span>{{ glAccountsIntendedUse }}</span>
                    </div>
                }
            </div>
            <div class="ws-flex-none ws-flex-align-self-center">
                <entity-import-progress [importFile]="importFileModel" [clickable]="false"></entity-import-progress>
            </div>
        </div>
        <div class="ws-flex-container-vertical ws-flex-auto">
            <!-- column mapping step -->
            @if (importStep === importSteps.ColumnMapping) {
                <entity-import-column-mapping-step class="ws-flex-auto ws-stretch ws-flex-container-vertical"
                                                   [importId]="importId"
                >
                </entity-import-column-mapping-step>
            }
            <!-- editing step -->
            @if (importStep === importSteps.Editing) {
                <entity-import-editing-step class="ws-flex-auto ws-stretch ws-flex-container-vertical"
                                            [importFileModel]="importFileModel"
                                            [busyRefId]="busyRefId"
                                            [selectedRowsInfo$]="selectedRowsInfo$">
                </entity-import-editing-step>
            }
        </div>
        <!-- buttons -->
        @if (importStep) {
            <div class="ws-flex-container-horizontal" style="margin: 10px 0;">
                <div class="ws-flex-container-horizontal ws-flex-auto">
                    @if (isGoBackVisible) {
                        <div class="grid-action-button-wrapper"
                             helpTooltip
                             [helpContentId]="backHelpContentId"
                             position="top">
                            <button type="button"
                                    class="ace-btn btn-sm btn-primary"
                                    [disabled]="!isGoBackEnabled"
                                    (click)="goBack()">
                                <span><i class="fa fa-arrow-left" style="margin-right: 8px"></i>Back</span>
                            </button>
                        </div>
                    }
                    <div class="action-button-wrapper"
                         helpTooltip
                         helpContentId="import-process.close"
                         position="top">
                        <button type="button"
                                class="ace-btn btn-sm btn-primary"
                                [disabled]="!isCloseEnabled"
                                (click)="onCloseClick()">
                            <span>Close</span>
                        </button>
                    </div>
                </div>
                <div class="ws-flex-container-horizontal ws-flex-none">
                    @if (isRevalidateVisible) {
                        <div class="action-button-wrapper"
                             helpTooltip
                             helpContentId="import-process.revalidate"
                             position="top">
                            <button type="button"
                                    class="ace-btn btn-sm btn-primary"
                                    (click)="revalidate()">
                                <span>Revalidate</span>
                            </button>
                        </div>
                    }
                    @if (isDeleteVisible) {
                        <div class="action-button-wrapper"
                             helpTooltip
                             [helpContentId]="deleteHelpContentId"
                             position="top">
                            <button type="button"
                                    class="ace-btn btn-sm btn-primary btn-danger"
                                    [disabled]="!isDeleteEnabled"
                                    (click)="delete()">
                                <span>Delete</span>
                            </button>
                        </div>
                    }
                    @if (isMarkAsCompletedVisible) {
                        <div class="action-button-wrapper"
                             helpTooltip
                             [helpContentId]="markCompletedHelpContentId"
                             position="top">
                            <button type="button"
                                    class="ace-btn btn-sm btn-primary btn-danger"
                                    [disabled]="!isMarkAsCompletedEnabled"
                                    (click)="markAsCompleted()">
                                <span>Mark as Completed</span>
                            </button>
                        </div>
                    }
                    @if (isGoNextVisible) {
                        <div class="action-button-wrapper"
                             helpTooltip
                             [helpContentId]="nextHelpContentId"
                             position="top">
                            <button type="button"
                                    class="ace-btn btn-sm btn-primary btn-success"
                                    [disabled]="!isGoNextEnabled"
                                    (click)="goNext()">
                                <span>{{ nextText }}<i class="fa fa-arrow-right" style="margin-left: 8px"></i></span>
                            </button>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
}
